import { useEffect } from 'react';
import { FormikProvider, useFormik } from 'formik';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import FilledInBy from './common/FilledInBy';
import Title from './common/Title';

export default function StarsModal(props: {
	fillInBy: graphql.EvaluationFillInBy;
	item: graphql.EvaluationStarsItem;
	onChange: (item: graphql.EvaluationStarsItem, fillInBy: graphql.EvaluationFillInBy) => void;
}) {
	const { t } = useTranslation();

	const formik = useFormik({
		initialValues: {
			title: props.item.title,
			fillInBy: props.fillInBy,
		},
		onSubmit: () => {},
	});

	useEffect(() => {
		if (!formik.values.title.find(({ text }) => text.length > 0)) {
			return;
		}

		props.onChange(
			{
				...props.item,
				title: formik.values.title,
			},
			formik.values.fillInBy,
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formik.values.title, formik.values.fillInBy]);

	return (
		<FormikProvider value={formik}>
			<Title label={t('common.settings.evaluationForms.stars.question.label')} />
			<FilledInBy />
		</FormikProvider>
	);
}
